import { render } from "./InformePedidos.vue?vue&type=template&id=4944488c&scoped=true"
import script from "./InformePedidos.vue?vue&type=script&lang=js"
export * from "./InformePedidos.vue?vue&type=script&lang=js"

import "./InformePedidos.vue?vue&type=style&index=0&id=4944488c&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4944488c"]])

export default __exports__